import parse from 'html-react-parser'

import { CollapsibleItemArrowRight } from '@components/v2/collapsible-item-arrow-right'
import Head from 'next/head'

export const FAQCalculadoraSolarSection = () => {
  const FAQ = [
    {
      question: 'O que é uma calculadora solar?',
      answer:
        'A calculadora de energia solar permite que você determine o tamanho e os custos ideais do sistema fotovoltaico de acordo com seu perfil de consumo. Além disso, nosso simulador de energia solar fornece informações precisas sobre a economia potencial em sua conta de luz. Descubra como nosso simulador de energia solar pode otimizar seus investimentos em sustentabilidade e eficiência energética.'
    },
    {
      question: 'Como funciona a calculadora solar?',
      answer:
        'Uma calculadora solar funciona da seguinte forma: por meio dos dados informados no formulário do simulador de energia solar, faremos uma estimativa sobre qual é a potência do sistema que precisa ser instalado em sua residência ou empresa. <br /><br /> Com a calculadora solar disponibilizada pelo Portal Solar, em poucos segundos você faz a simulação de energia solar e descobre qual é a área mínima necessária para instalação, a quantidade de painéis e suas respectivas capacidades em watts, além de informar qual é a estimativa de economia anual que será gerada após a instalação.'
    },
    {
      question: 'Como simular energia solar?',
      answer:
        'É muito rápido e fácil realizar o cálculo do seu gerador de energia solar com um simulador fotovoltaico. Com apenas algumas informações na calculadora de energia solar, você rapidamente tem o resultado do seu projeto.<br /><br />Primeiramente, você precisa informar os seus dados de consumo e localização para que a calculadora solar consiga simular o seu projeto. Todos os dados utilizados para simular energia solar são guardados em sigilo de acordo com a nossa política de privacidade.<br /><br />Após o fornecimento dos dados, o simulador fotovoltaico realiza todos os cálculos em poucos segundos para entregar os principais resultados do seu sistema fotovoltaico. As informações apresentadas pela calculadora de energia solar englobam o tamanho, geração elétrica e retorno financeiro do projeto.'
    },
    {
      question: 'Quais dados são necessários para simular energia solar?',
      answer:
        'Para usar o simulador solar online do Portal Solar você vai precisar dos seguintes dados: nome e e-mail; CEP; nome da distribuidora de energia; e o seu gasto mensal com a conta de luz. Basta preencher o formulário da calculadora solar com esses itens para realizar a simulação.'
    },
    {
      question:
        'Com a calculadora solar eu posso descobrir quanto custa instalar energia solar?',
      answer:
        'Você consegue descobrir rapidamente quantos painéis solares serão necessários e quanto custa instalar energia solar em sua empresa ou residência por meio da calculadora solar.<br /><br />Para descobrir a resposta, basta preencher o formulário com os seus dados e o nosso simulador solar vai fazer todo o cálculo, trazendo as informações que você precisa com clareza e simplicidade.'
    },
    {
      question: 'Quais resultados a calculadora de energia solar fornece?',
      answer:
        'Com a calculadora de energia solar você saberá a quantidade de painéis, potência instalada, área mínima necessária, produção mensal, economia anual. Para ter um orçamento detalhado, por favor prossiga para a próxima etapa da calculadora.'
    },
    {
      question:
        'O simulador fotovoltaico calcula o payback do investimento em energia solar?',
      answer:
        'Um dos fatores mais importantes ao simular energia solar é saber em quanto tempo você obterá o retorno do valor investido nos painéis e no sistema. Esse cálculo é feito estimando o valor economizado mensalmente com a conta de luz. Dessa forma, o simulador fotovoltaico é capaz de projetar em quantos meses você terá poupado o suficiente para pagar pelo preço do equipamento.'
    },
    {
      question: 'O que fazer com o resultado da calculadora solar?',
      answer:
        'Após utilizar a calculadora solar, caso o resultado seja interessante, você deve prosseguir para a etapa de orçamento preenchendo dados adicionais para nossa equipe fazer o atendimento corretamente. <br />Não se preocupe! - o orçamento é gratuito e sem compromisso.'
    },
    {
      question:
        'Tenho baixo consumo em energia elétrica, consigo simular energia solar mesmo assim?',
      answer:
        'A calculadora solar apresenta a melhor solução para os mais variados perfis de consumos. Preencha o simulador de energia solar com seus dados e o Portal Solar indicará qual a melhor opção para você.'
    },
    {
      question:
        'Por que tenho que informar o valor do meu gasto com energia elétrica e qual é minha distribuidora de energia na calculadora solar?',
      answer:
        'Essas informações são necessárias para que a calculadora solar possa lhe oferecer os melhores resultados de acordo com seu consumo e custo de energia elétrica em sua localização.<br /><br />As tarifas de energia variam conforme a distribuidora de energia e consumo mensal ajuda a entender qual é seu perfil de consumo e suas necessidades. Com esses dados corretos, a calculadora solar apresenta a solução ideal para as suas necessidades.'
    },
    {
      question:
        'A calculadora solar pode ser utilizada por qualquer tipo de consumidor?',
      answer:
        'A calculadora solar permite que qualquer perfil de consumidor descubra quanto terá que investir e qual será a economia com a conta de luz com um sistema fotovoltaico. Ela pode ser utilizada como um simulador de energia solar para residência e para uma empresa.'
    },
    {
      question: 'Preciso ser uma empresa para instalar energia solar?',
      answer:
        'Não, pessoas físicas e pessoas jurídicas contam com a oportunidade de economizar com a energia solar. Com o simulador de energia solar você poderá descobrir qual é a solução mais adequada para a sua necessidade. Basta fornecer os dados adequados no simulador fotovoltaico.'
    },
    {
      question: 'Quem é o Portal Solar?',
      answer:
        'O Portal Solar é a marca líder de energia solar do Brasil. Estamos no mercado há 9 anos e atuamos desde 2021 como franqueadora de venda e instalação de sistemas fotovoltaicos.<br /><br />Somos uma empresa sólida e pautada pela ética, com qualidade atestada por nossos clientes e franqueados. Faça um orçamento por meio do nosso simulador de energia solar e conheça qual é a melhor forma de economizar com a conta de luz.'
    }
  ]

  return (
    <section
      id="faq-calculator-section"
      className="w-full snap-always snap-start lg:bg-white md:pt-14 px-4 md:px-8 pb-48 md:mt-36 mt-16"
    >
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: FAQ.map(({ question, answer }) => ({
                '@type': 'Question',
                name: question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `<p>${answer}</p>`
                }
              }))
            })
          }}
        />
      </Head>

      <div className="w-full max-w-7xl mx-auto">
        <h2 className="w-full text-2xl md:text-[35px] leading-[30px] lg:text-[30px] lg:leading-[35px] 2xl:text-[35px] tracking-[-2.5%] text-v3-gray-600 lg:text-left lg:relative lg:top-0 lg:w-full lg:px-0">
          Perguntas Frequentes
        </h2>

        <ul className="mt-6 md:mt-10">
          {FAQ.map(({ question, answer }, index) => (
            <CollapsibleItemArrowRight
              key={index}
              question={question}
              className="mb-5"
            >
              <p className="text-base text-v3-gray-400">{parse(answer)}</p>
            </CollapsibleItemArrowRight>
          ))}
        </ul>
      </div>
    </section>
  )
}
